import React from 'react';
import {useEffect, useState} from 'react';
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom';
import { API } from 'aws-amplify';
import DashboardHeatmapCard from '../DashboardHeatmapCard'
import TopCategoriesCard from './TopCategoriesCard'
import TopTimelineCard from './TopTimelineCard'
import ScheduleFrequencyCard from './ScheduleFrequencyCard'
import TimelineCard from './TimelineCard'
import AlertModal from '../../AlertModal'
import DropdownClassic from "../../../components/DropdownClassic"

function OptimalShedulingContent({updateContentState, setAlertModalState, authToken}) {

  const [heatmapFilter, setHeatmapFilter] = useState({period: 'Per day', audience: 'All Audiences'});
  const [heatmapData, setHeatmapData] = useState({});
  const [audiences, setAudiences] = useState([]);

  const [topDays, setTopDays] = useState([]);
  const [topTimes, setTopTimes] = useState([]);
  const [topIntervals, setTopIntervals] = useState([]);
  const [topSimpleDayPatterns, setTopSimpleDayPatterns] = useState({});
  const [topSimpleWeekPatterns, setTopSimpleWeekPatterns] = useState({});

  const [frequencyData, setFrequencyData] = useState({});
  const [timelineNotifs, setTimelineNotifs] = useState('');

  useEffect(() => {
    fetchFilterData()
    fetchTopDays()
    fetchTopTimes()
    fetchTopIntervals()
    fetchTopSimpleDayPatterns()
    fetchTopSimpleWeekPatterns()
    fetchTimelineNotifs()
    fetchFreqData()
  }, [authToken]);

  async function fetchFilterData() {

    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'distinct-markets'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };

    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('audiences' in response){
          setAudiences(response['audiences'])
          fetchHeatmap()
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchHeatmap() {
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-heatmap',
        period: heatmapFilter['period'],
        audience: heatmapFilter['audience']
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };

    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('heatmap' in response){
          setHeatmapData(response['heatmap'])
        }
        else{
          console.log('Heatmap data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function updateFilter(key, value){
    heatmapFilter[key] = value
    setHeatmapFilter(heatmapFilter)
    fetchFilterData()
  }

  async function fetchTopDays(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-top-dayofweek'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {

        if('top' in response){
          setTopDays(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTopTimes(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-top-timeofday'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setTopTimes(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTopIntervals(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-top-interval'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('top' in response){
          setTopIntervals(response['top'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTimelineNotifs(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-timeline-day'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {

        console.log(response['notifs'])
        if('notifs' in response){
          setTimelineNotifs(
            response['notifs'].map((item, index) => (
              <TimelineCard notifs={item}/>
            ))
          )
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTopSimpleDayPatterns(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-timeline-simple-day'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('patterns' in response){
          setTopSimpleDayPatterns(response['patterns'])
        }
        else{
          console.log('Top simple day patterns not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchTopSimpleWeekPatterns(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-timeline-simple-week'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('patterns' in response){
          setTopSimpleWeekPatterns(response['patterns'])
        }
        else{
          console.log('Top simple week patterns not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function fetchFreqData(){
    const apiName = 'DashboardAPI';
    const path = '/emulator/query';
    const params = {
      queryStringParameters: {
        case: 'sched-freq-week'
      },
      headers: {
        Authorization: `Bearer ${authToken}`
      },
    };
    API
      .get(apiName, path, params)
      .then(async(response) => {
        if('freq' in response){
          setFrequencyData(response['freq'])
        }
        else{
          console.log('Top data not found.')
        }
      })
      .catch(error => {
        console.log('Error executing request.')
        console.log(error)
      });
  }

  async function premiumFeature(e){
    setAlertModalState({title: 'Contact Us ✉', message: 'To access this feature and others which facilitate greater ' +
        'in-depth analysis, please send us an email (hello@empushy.com) and we will add you to our exclusive beta group.'})
  }

  return (

    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full">

      <Helmet>
        <title>EmPushy | Scheduling</title>
      </Helmet>

      {/* Page content */}
      <div className="max-w-full flex flex-col lg:flex-row lg:space-x-8 xl:space-x-16 ">
        {/* Content */}
        <div>
          <div className="mb-6">
            <ul className="inline-flex flex-wrap text-sm font-medium">
              <li className="flex items-center">
                <div className="text-slate-500 hover:text-pink-500 cursor-pointer"
                     onClick={()=>updateContentState('home')}>Home</div>
                <svg className="h-4 w-4 fill-current text-slate-400 mx-3" viewBox="0 0 16 16">
                  <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                </svg>
              </li>
              <li className="flex items-center">
                <a className="text-slate-500">Optimal Scheduling</a>
              </li>
            </ul>
          </div>
          <header className="mb-4">
            {/* Title */}
            <h1 className="text-2xl md:text-3xl text-slate-800 font-bold mb-2">Optimal Scheduling</h1>
            <p className="mb-6 text-justify">The time and day you schedule your campaigns to be delivered to your audience has a huge impact
              on the performance. Depending on the market type, campaign CTA, content type and a host of other
              features, the day and time that works best can differ quite a lot. This interactive guide will help take
              the guesswork out of your campaign scheduling and help you achieve great results.</p>
          </header>

          {/* Image */}
          <div className="mb-10">
            <DashboardHeatmapCard data={heatmapData} title={'Message Scheduling'}
                                    hint={'Scheduled delivery of messages to audience subscribers.'}
                                    filter={heatmapFilter} updateFilter={updateFilter}
                                    audiences={audiences}/>
          </div>

          <div>
            <p className="mb-6 text-justify">Depending on your audience, you will need to push a certain number of campaigns
            per day, week and month in order to stay relevant and keep your subscribers engaged ☝️ These campaigns
            don't need to be constantly asking your audience to make a purchase or engage with your content,
            but can simply make them aware that you care about them, the events they're interested in and have
            a vested interest in helping them achieve their goals ✔️ Check out the frequency of campaigns pushed
            in different markets below. Are you scheduling too many or not enough?</p>
          </div>
          <div className="mb-10">
            <ScheduleFrequencyCard title={"Campaigns Launched Over Time"} data={frequencyData}/>
          </div>

          <div>
            <h2 className="text-xl leading-snug text-slate-800 font-bold mb-2">Contact Frequency</h2>
            <p className="mb-6">The frequency with which you reach out to your subscribers matters a lot. Too much
            can be off-putting and make your audience feel overwhelmed. Too little and they feel under appreciated.
            Striking the perfect balance is tricky, but with our recommendations (built upon analysing <i>thousands</i> of
            campaigns), you can perfect this skill and even automate the scheduling process.</p>
            <p className="mb-6">The charts below demonstrate the most common campaign push patterns for different
              periods and audience types <strong>over the past month</strong>:</p>
          </div>
          <div className="mb-10">
            {
              timelineNotifs!=''?
                <div>
                  <div className="flex justify-center space-x-4">
                    <DropdownClassic options={[{id: 0, period: 'Per Day'}, {id: 1, period: 'More...'}]} selectedFilter={'Market'}
                                     updateFunc={premiumFeature}/>
                    <DropdownClassic options={[{id: 0, period: 'All Audiences'}, {id: 1, period: 'More...'}]} selectedFilter={'Market'}
                                     updateFunc={premiumFeature}/>
                  </div>
                  {timelineNotifs}
                </div>:
              <div className="sm:flex justify-items-center mt-5 w-full">
                <div className="m-auto">
                  <svg className="animate-spin h-8 w-8" viewBox="0 0 100 100">
                    <circle cx="50" cy="50" r="45" stroke="#F7699F" strokeWidth="10" fill="transparent" strokeLinecap="round"
                            strokeDasharray="283" strokeDashoffset="75"/>
                  </svg>
                </div>
              </div>
            }
          </div>
          <div className="mt-6 w-full text-center">
            <button
              className="btn bg-white border-gray-200 hover:border-gray-300 text-gray-500 hover:text-gray-600"
              onClick={() =>
                setAlertModalState({title: 'Contact Us ✉', message: 'To access this feature and others which facilitate greater ' +
                    'in-depth analysis, please send us an email (hello@empushy.com) and we will add you to our exclusive beta group.'})
              }>
              Load more
            </button>
          </div>


          {/* Post content */}
          {/*<div>
                      <h2 className="text-xl leading-snug text-slate-800 font-bold mb-2">Meetup Details</h2>
                      <p className="mb-6">In the world of AI, behavioural predictions are leading the charge to better machine learning.</p>
                      <p className="mb-6">
                        There is so much happening in the AI space. Advances in the economic sectors have seen automated business practices rapidly
                        increasing economic value. While the realm of the human sciences has used the power afforded by computational capabilities to
                        solve many human based dilemmas. Even the art scene has adopted carefully selected ML applications to usher in the technological
                        movement.
                      </p>
                      <p className="mb-6">
                        Join us every second Wednesday as we host an open discussion about the amazing things happening in the world of AI and machine
                        learning. Feel free to share your experiences, ask questions, ponder the possibilities, or just listen as we explore new topics
                        and revisit old ones.
                      </p>
                    </div>
                    <hr className="my-6 border-t border-slate-200" />*/}

        </div>

        {/* Sidebar */}
        <div className="space-y-4">
          {/* 1st block */}
          <TopCategoriesCard title="Popular Day to Schedule" category="Day of Week" data={topDays}
          hint="Popular days of week to schedule messages to subscribers
                              (based on an analysis of campaigns pushed over the past month)"/>
          <TopCategoriesCard title="Popular Time to Schedule" category="Time of Day" data={topTimes}
                             hint="Popular times of day (hour) to schedule messages to subscribers
                              (based on an analysis of campaigns pushed over the past month)"/>
          <TopCategoriesCard title="Popular Intervals between Campaigns" category="Push Interval" data={topIntervals}
                             hint="Popular intervals between messages pushed to subscribers
                              (based on an analysis of campaigns pushed over the past month)"/>
          <TopTimelineCard title="Popular 24h Campaign Timelines" data={topSimpleDayPatterns}
                           hint="Popular 24h timeline of pushed campaigns (based on an analysis of campaigns pushed over
                                  the past month)"/>
          <TopTimelineCard title="Popular Weekly Campaign Timelines" data={topSimpleWeekPatterns}
                           hint="Popular weekly timeline of pushed campaigns (based on an analysis of campaigns pushed over
                                  the past month)"/>

          {/* 2nd block */}
          {/*<div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 lg:w-72 xl:w-80">
                      <div className="flex justify-between space-x-1 mb-5">
                        <div className="text-sm text-slate-800 font-semibold">Attendees (127)</div>
                        <a className="text-sm font-medium text-indigo-500 hover:text-indigo-600" href="#0">
                          View All
                        </a>
                      </div>
                      <ul className="space-y-3">
                        <li>
                          <div className="flex justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage08} width="32" height="32" alt="User 08" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Carolyn McNeail</span>
                              </div>
                            </div>
                            <button className="text-slate-400 hover:text-slate-500 rounded-full">
                              <span className="sr-only">Menu</span>
                              <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                <circle cx="16" cy="16" r="2" />
                                <circle cx="10" cy="16" r="2" />
                                <circle cx="22" cy="16" r="2" />
                              </svg>
                            </button>
                          </div>
                        </li>
                        <li>
                          <div className="flex justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage01} width="32" height="32" alt="User 01" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Dominik Lamakani</span>
                              </div>
                            </div>
                            <button className="text-slate-400 hover:text-slate-500 rounded-full">
                              <span className="sr-only">Menu</span>
                              <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                <circle cx="16" cy="16" r="2" />
                                <circle cx="10" cy="16" r="2" />
                                <circle cx="22" cy="16" r="2" />
                              </svg>
                            </button>
                          </div>
                        </li>
                        <li>
                          <div className="flex justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage03} width="32" height="32" alt="User 03" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Ivan Mesaros</span>
                              </div>
                            </div>
                            <button className="text-slate-400 hover:text-slate-500 rounded-full">
                              <span className="sr-only">Menu</span>
                              <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                <circle cx="16" cy="16" r="2" />
                                <circle cx="10" cy="16" r="2" />
                                <circle cx="22" cy="16" r="2" />
                              </svg>
                            </button>
                          </div>
                        </li>
                        <li>
                          <div className="flex justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage05} width="32" height="32" alt="User 05" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Maria Martinez</span>
                              </div>
                            </div>
                            <button className="text-slate-400 hover:text-slate-500 rounded-full">
                              <span className="sr-only">Menu</span>
                              <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">
                                <circle cx="16" cy="16" r="2" />
                                <circle cx="10" cy="16" r="2" />
                                <circle cx="22" cy="16" r="2" />
                              </svg>
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>*/}

          {/* 3rd block */}
          {/*<div className="bg-white p-5 shadow-1 rounded-sm border border-slate-200 lg:w-72 xl:w-80">
                      <div className="flex justify-between space-x-1 mb-5">
                        <div className="text-sm text-slate-800 font-semibold">Invite Friends</div>
                        <a className="text-sm font-medium text-indigo-500 hover:text-indigo-600" href="#0">
                          View All
                        </a>
                      </div>
                      <ul className="space-y-3">
                        <li>
                          <div className="flex items-center justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage02} width="32" height="32" alt="User 02" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Haruki Masuno</span>
                              </div>
                            </div>
                            <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                              Invite
                            </button>
                          </div>
                        </li>
                        <li>
                          <div className="flex items-center justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage04} width="32" height="32" alt="User 04" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Joe Huang</span>
                              </div>
                            </div>
                            <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                              Invite
                            </button>
                          </div>
                        </li>
                        <li>
                          <div className="flex items-center justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage06} width="32" height="32" alt="User 06" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Carolyn McNeail</span>
                              </div>
                            </div>
                            <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                              Invite
                            </button>
                          </div>
                        </li>
                        <li>
                          <div className="flex items-center justify-between">
                            <div className="grow flex items-center">
                              <div className="relative mr-3">
                                <img className="w-8 h-8 rounded-full" src={UserImage08} width="32" height="32" alt="User 08" />
                              </div>
                              <div className="truncate">
                                <span className="text-sm font-medium text-slate-800">Lisa Sitwala</span>
                              </div>
                            </div>
                            <button className="text-xs inline-flex font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                              Invite
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>*/}
        </div>
      </div>
    </div>
  );
}

export default OptimalShedulingContent;